import Reveal from "@/components/Reveal";

const steps = [
  { num: "01", title: "Consultation", text: "Understand requirements, space and budget." },
  { num: "02", title: "Planning", text: "Plan materials, execution and project requirements." },
  { num: "03", title: "Execution", text: "Professional on-site execution with attention to detail." },
  { num: "04", title: "Finishing", text: "Final finishing, inspection and handover." },
];

export default function Process() {
  return (
    <section data-testid="process-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <Reveal className="max-w-2xl mb-16">
          <p className="text-xs tracking-[0.25em] uppercase font-semibold text-zinc-500 mb-5">05 &middot; Our Process</p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-zinc-950">
            From Vision to Completion
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {steps.map((s, i) => (
            <Reveal key={s.num} delay={i * 0.08}>
            <div data-testid={`process-step-${s.num}`} className="relative pt-8 border-t border-zinc-200">
              <span className="absolute -top-px left-0 w-12 border-t border-zinc-950" />
              <span className="font-heading text-4xl font-light text-zinc-300">{s.num}</span>
              <h3 className="mt-5 font-heading text-xl font-medium text-zinc-950">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-zinc-600">{s.text}</p>
              {i < steps.length - 1 && (
                <span className="hidden lg:block absolute top-8 right-0 w-6 border-t border-zinc-200" />
              )}
            </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
